module.exports = __webpack_public_path__ + "img/horizontal_7_2_pp2_2.306c1a1f.png";